import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import "./EncabezadoOrdenes.scss";
import AutoCompleteDropdown from "../../../Base/Components/Form/AutoCompleteDropdown";
import { Calendar } from "primereact/calendar";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { useState } from "react";
import { Checkbox } from "primereact/checkbox";
import RequisasOverlayPanel from "../../Compras/Ordenes/RequisasOverlayPanel"
import { SplitButton } from "primereact/splitbutton";
import OrdenesComprasReporte from "./Reporte/OrdenesComprasReporte";

const EncabezadoOrdenesCompras = ({
  values,
  handleInputChange,
  habilitar,
  Functions,
  setNumber,
  inputValues,
}) => {
  const [selected, setSelected] = useState([]);
  const [showReporte, setShowReporte]= useState(false);
  const [lenguaje, setLenguaje]= useState('es');

  const items = [
      {
        className: "p-componentt",
        label: "Ingles",
        icon: "",
        command: () => {
          setLenguaje('en')
          setShowReporte(true)
          // window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${values.NumeroOrden}/1`, values.NumeroOrden, 'height=1200,width=1000')
          }
        },
      {
        label: "Español",
        icon: "",
        command: () => {
          setLenguaje('es')
          setShowReporte(true)
          // window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${values.NumeroOrden}/2`, values.NumeroOrden, 'height=1200,width=1000')
          }
      },
  ];

  return (
    <div className="flex justify-content-center">
      <div className="encabezado__Contenedor_OrdenCompra">
        <div className="p-float-label">
          <InputText
            id="NumeroOrden"
            type="text"
            name="NumeroOrden"
            value={values.NumeroOrden}
            onChange={handleInputChange}
            style={{ fontWeight: "bold", fontSize: "small" }}
            // onKeyDown={() => Functions.getInfo(values.NumeroOrden)}
          />
          <label htmlFor="No. Orden">No. Orden</label>
          <Button
            icon="pi pi-search"
            type="button"
            className="p-button-info"
            onClick={(e) => Functions.getInfo(values.NumeroOrden)}
            id="#buscarOC"
            tooltip="Buscar Orden"
            tooltipOptions={{
              className: "purple-tooltip",
              position: "top",
            }}
          />
        </div>

        <div className="p-float-label">
          <InputText
            id="OC"
            type="text"
            name="OC"
            value={values.OC}
            disabled={!habilitar}
            onChange={handleInputChange}
            style={{ minWidth: "17rem" }}
          />
          <label htmlFor="OCE">OCE</label>
        </div>

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Proveedor}
          items={inputValues.Proveedores}
          field={"CustomerName"}
          name={"Proveedor"}
          handleInputChange={handleInputChange}
          tabIndex={1}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Cliente}
          items={inputValues.Clientes}
          field={"CustomerName"}
          name={"Cliente"}
          handleInputChange={handleInputChange}
          tabIndex={2}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Agente}
          items={inputValues.AgentesCompras}
          field={"AgentName"}
          name={"Agente"}
          handleInputChange={handleInputChange}
          tabIndex={3}
        />

        <span className=" p-float-label Date encabezado__contenido">
          <Calendar
            id="Date"
            name="Date"
            disabled
            value={values.Date}
            onChange={handleInputChange}
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            showIcon
          />
          <label htmlFor="Date">Fecha</label>
        </span>

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Terminos}
          items={inputValues.Terminos}
          field={"TermName"}
          name={"Terminos"}
          handleInputChange={handleInputChange}
          tabIndex={4}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.TerminosPago}
          items={inputValues.TerminosPago}
          field={"TermName"}
          name={"TerminosPago"}
          label={"Terminos de Pago"}
          handleInputChange={handleInputChange}
          tabIndex={4}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.TipoCompra}
          items={inputValues.TipoCompras}
          field={"PurchaseType"}
          name={"TipoCompra"}
          handleInputChange={handleInputChange}
          tabIndex={5}
          label={"Tipo Compra"}
        />

        <AutoCompleteDropdown
          enable={false}
          value={values.Estado}
          items={inputValues.Estados}
          field={"StatusName"}
          name={"Estado"}
          handleInputChange={handleInputChange}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Area}
          items={inputValues.Areas}
          field={"Area"}
          name={"Area"}
          handleInputChange={handleInputChange}
          tabIndex={6}
          label={"Área"}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Bodega}
          items={inputValues.Warehouses}
          field={"Warehouse"}
          name={"Bodega"}
          handleInputChange={handleInputChange}
          tabIndex={7}
        />

        <AutoCompleteDropdown
          enable={habilitar}
          value={values.Moneda}
          items={inputValues.Monedas}
          field={"Currency"}
          name={"Moneda"}
          handleInputChange={handleInputChange}
          tabIndex={8}
        />

        <AutoCompleteDropdown
          enable={values.Cliente && habilitar}
          value={values.ClienteDetalle}
          items={inputValues.ClientesDetalle}
          field={"CompanyName"}
          name={"ClienteDetalle"}
          handleInputChange={handleInputChange}
          tabIndex={9}
          label={"Entregar A"}
          itemTemplate={(e) => {
            return (
              <div className="d-flex">
                <div className="pe-2">{e.Address + " | "}</div>
                <div className="pe-2">{e.CompanyName + " | "}</div>
                <div className="pe-2">{e.Country}</div>
              </div>
            );
          }}
        />

        <span className="encabezado__contenido RequiredDate p-float-label">
          <Calendar
            id="RequiredDate"
            name="RequiredDate"
            disabled={!habilitar}
            value={values.RequiredDate}
            onChange={(e) => handleInputChange(e, "RequiredDate")}
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            showButtonBar
            showIcon
            tabIndex={9}
          />
          <label htmlFor="TipoCompra">Req. Desde</label>
        </span>

        <span className="encabezado__contenido RequiredDateH p-float-label">
          <Calendar
            id="RequiredDateH"
            name="RequiredDateH"
            disabled={!habilitar}
            value={values.RequiredDateH}
            onChange={(e) => handleInputChange(e, "RequiredDateH")}
            dateFormat="dd/mm/yy"
            mask="99/99/9999"
            yearRange="2010:2030"
            tabIndex={10}
            monthNavigator
            showButtonBar
            yearNavigator
            showIcon
          />
          <label htmlFor="TipoCompra">Req. Hasta</label>
        </span>

        <span className="Comment p-float-label encabezado__contenido">
          <InputTextarea
            disabled={!habilitar}
            id="Comment"
            name="Comment"
            value={values.Comment}
            onChange={handleInputChange}
            autoResize={true}
            cols={73}
            placeholder
            className={"p-inputtext-sm block mb-2 mx-1 block"}
            yearNavigator
            yearRange="2010:2030"
            monthNavigator
          />
          <label htmlFor="TipoCompra">Comentario</label>
        </span>
      </div>

      <div className="d-flex align-items-center gap-3 mx-3">
        <div className="d-flex gap-2">
          <Button
            icon="pi pi-plus"
            disabled={!habilitar}
            type="button"
            className="p-button-info encabezado__herramienta-botones"
            tooltip="Agregar items"
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            onClick={Functions.addNewRow}
          />
          <Button
            icon="pi pi-save"
            disabled={!habilitar}
            type="submit"
            className="p-button-primary encabezado__herramienta-botones"
            onClick={Functions.guardarEncabezado}
            tooltip="Guadar"
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            style={{ marginLeft: 1 }}
          />
          <Button
            icon="pi pi-pencil"
            type="button"
            className="p-button-secondary  encabezado__herramienta-botones"
            onClick={Functions.habilitarComponentes}
            tooltip="Editar"
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            style={{ marginLeft: 1 }}
          />
          <Button
            icon="pi pi-times"
            type="button"
            className="p-button-danger encabezado__herramienta-botones"
            onClick={() => Functions.eliminarItemDetalle("top")}
            tooltip="Eliminar"
            disabled={!habilitar}
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            style={{ marginLeft: 1 }}
          />

          <div className="d-flex flex-row">
              <SplitButton
                  label=""
                  disabled={habilitar}
                  icon="pi pi-print"
                  tooltip="Imprimir"
                  tooltipOptions={{ className: "purple-tooltip", position: "top" }}
                  onClick={(e) => {
                    setLenguaje('es')
                    setShowReporte(true)
                    // window.open(`${process.env.REACT_APP_ENV}/OrdenCompras/print/${values.NumeroOrden}/2`, values.NumeroOrden, 'height=1200,width=1000')
                  }
                  }
                  model={items}
              />
          </div>

          <Button
            icon="pi pi-book"
            type="button"
            className="p-button-info  encabezado__herramienta-botones"
            onClick={Functions.nuevaRequisa}
            tooltip="Nuevo"
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            style={{ marginLeft: 1 }}
          />
          <Button
            icon="pi pi-sync"
            type="button"
            className="p-button-info encabezado__herramienta-botones"
            onClick={() => Functions.getInfo()}
            tooltip="Cargar"
            tooltipOptions={{ className: "purple-tooltip", position: "top" }}
            style={{ marginLeft: 1 }}
          />
        </div>

        <div className="d-flex gap-2">
          <span className="p-float-label ">
            <InputNumber
              mode="decimal"
              currency="HNL"
              locale="en-US"
              minFractionDigits={2}
              maxFractionDigits={2}
              id="SubTotal"
              name="SubTotal"
              disabled
              value={values.SubTotal}
              onChange={setNumber}
            />
            <label id="label_comentario" htmlFor="SubTotal">
              SubTotal
            </label>
          </span>
          <span className=" p-float-label">
            <InputNumber
              mode="decimal"
              currency="HNL"
              locale="en-US"
              minFractionDigits={2}
              maxFractionDigits={2}
              id="Descuento"
              name="Descuento"
              disabled
              value={values.Descuento}
              onChange={setNumber}
            />
            <label id="label_comentario" htmlFor="Descuento">
              Descuento
            </label>
          </span>
          <span className=" p-float-label">
            <InputNumber
              id="ISV"
              mode="decimal"
              locale="en-US"
              minFractionDigits={2}
              maxFractionDigits={2}
              name="ISV"
              disabled
              value={values.ISV}
              onChange={setNumber}
            />
            <label id="label_comentario" htmlFor="Tax">
              Tax
            </label>
          </span>
          <span className="p-float-label">
            <InputNumber
              mode="decimal"
              currency="HNL"
              locale="en-US"
              minFractionDigits={2}
              maxFractionDigits={2}
              disabled
              id="Total"
              name="Total"
              value={values.Total}
              onChange={setNumber}
            />
            <label id="label_comentario" htmlFor="Total">
              Total
            </label>
          </span>
        </div>

        <div className="d-flex">
          <div className="d-flex align-items-center justify-content-center">
            <span className="field p-float-label">
              <RequisasOverlayPanel
                setNuevaFila={Functions.addRequisas}
                selectedPcs={selected}
                setSelectedPCs={setSelected}
                habilitar={!habilitar}
                Functions={Functions}
                IdMoneda={values.Moneda?.IdCurrency}
                IdProveedor={values.Proveedor?.IdCustomer}
                IsPro={values.Pro}
              />
            </span>
            <div>
              <Checkbox
                inputId="Pro"
                name="Pro"
                disabled={!habilitar}
                value={values.Pro}
                onChange={(e) =>
                  handleInputChange({ target: { value: !values.Pro } }, "Pro")
                }
                checked={values.Pro}
              />
              <label htmlFor="Pro">Pro</label>
            </div>
          </div>
        </div>
      </div>

      {showReporte &&(
          <OrdenesComprasReporte
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selected={values}
          setSelected={setSelected}
          lenguaje={lenguaje}
          getInfo={Functions.getInfo}
          />
      )}
    </div>
  );
};

export default EncabezadoOrdenesCompras;